import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { css } from "@emotion/core"

import Layout from '../components/layout'
import '../styles/index.scss'
import disenoStyles from '../styles/disenoweb.module.scss'
import headerStyles from '../styles/header.module.scss'
import homeStyles from '../styles/home.module.scss'

import { IoIosArrowRoundDown } from "react-icons/io";
import Metatags from '../components/metatag';
import Airbnb from "../assets/airbnb.svg"
import Nike from "../assets/nike.svg"
import Deliveroo from "../assets/deliveroo.svg"
import Braun from "../assets/braun.svg"
import Hopper from "../assets/hopper.svg"
import Flamingo from "../assets/flamingo.svg"

import socialCard from '../images/card.jpg'
import "react-alice-carousel/lib/alice-carousel.css";

// Iconos

import Atrayente from "../assets/atrayente.svg"
import Velocidad from "../assets/velocidad.svg"
import Responsive from "../assets/responsive-diseno.svg"
import Listo from "../assets/listo-diseno.svg"

// Background
import BackgroundPointBlack from "../../static/background-point-black.svg"
import BackgroundPoint from "../../static/background-point.svg"
import BackgroundX from "../../static/background-x.svg"

// Iconos ventajas
import Rapido from "../assets/rapido.svg"
import Seguro from "../assets/seguro.svg"
import Confiable from "../assets/confiable.svg"
import SEO from "../assets/ventaja-seo.svg"
import Escalable from "../assets/escalable.svg"

const IndexPage = () => {
    
    const data = useStaticQuery(graphql`
        query{
            site{
                siteMetadata{
                    title
                    description
                    siteUrl
                }
            }
            image2: file (relativePath: {eq: "portfolio.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            image3: file (relativePath: {eq: "code.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            image4: file (relativePath: {eq: "diseno-web.jpg"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            image5: file (relativePath: {eq: "contentful.jpg"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            image6: file (relativePath: {eq: "webflowcms.jpg"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            image7: file (relativePath: {eq: "diseno-web-sevilla.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            icon1: file (relativePath: {eq: "clientes.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            icon2: file (relativePath: {eq: "experiencia-icon.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            icon3: file (relativePath: {eq: "ingresos.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            icon4: file (relativePath: {eq: "posicion-seo.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            cohete: file (relativePath: {eq: "cohete.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            
        }
    
    `)
    
    return(
        <Layout>
            <Metatags
                title={`${data.site.siteMetadata.title} | Diseño de páginas Web en Sevilla`}
                description={data.site.siteMetadata.description}
                thumbnail={`${data.site.siteMetadata.siteUrl}${socialCard}`}
                url= {data.site.siteMetadata.siteUrl}
            />
            <section className={headerStyles.header_wrapper}>

                <div className={headerStyles.header_wrapper_left}>
                    <h1 className={headerStyles.header_wrapper_title}>Diseño de páginas web en Sevilla</h1>
                    <h2 className={headerStyles.header_wrapper_main}>Diseño y desarrollo de <span className={headerStyles.header_wrapper_main_highlight}>Web profesionales</span>
                    </h2>
                    <p className={headerStyles.header_wrapper_text}>Diseño páginas web basándome en tres premisas, Rapidez, Atracción y Confianza.</p>
                    <Link to='/diseno-web-sevilla#mas' className="btn btn__white btn__animated">Ver más</Link>
                </div>

                <div className={headerStyles.header_wrapper_right}>
                    <Img fluid={data.image7.childImageSharp.fluid} alt="Diseño web sevilla" loading="lazy"/>
                    
                </div>

            </section>
            <IoIosArrowRoundDown className={headerStyles.header_arrow} />
        

            <section className={disenoStyles.intro} id="mas">
                <div className={disenoStyles.intro_wrapper}>

                    <div className={disenoStyles.intro_wrapper_up}>
                    
                        <h2 className={headerStyles.header_titles_text}>¿Cómo puedo ayudarte?</h2>
                            <Img fluid={data.image7.childImageSharp.fluid} alt="Diseño web sevilla" loading="lazy" css={css`

                                @media (min-width: 770px){
                                    display: none;
                                    margin: 2rem 0;

                                }
                            
                            
                            `}/>

                        <h3 className={headerStyles.header_titles_subtext}>Mi misión es ayudar a empresas y nuevos proyectos a alcanzar sus objetivos mediante el diseño y desarrollo de su web.</h3>

                        <p>Mi ventaja competitiva respecto a otros diseñadores web en Sevilla es que creo sitios web a medida. Las páginas web que creo son completamente personalizados y autogestionables. <br></br><br></br>Priorizo sobretodo el diseño, la adaptabilidad y la velocidad de respuesta del sitio web.</p>

                        <p>Implemento estrategias de diseño basadas en la investigación del mercado y la competencia. Centrando mis esfuerzos en ofrecer a los visitantes de tu sitio web, la mejor experiencia de usuario. <br></br><br></br>Esto da como resultado, una mejor ranking de búsqueda en Google, convirtiendo usuarios en clientes potenciales.</p>

                    </div>

                    <div className={disenoStyles.intro_wrapper_box}>
                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Atrayente /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Diseño web atrayente</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>Distínguete de tu competencia con un diseño web llamativo y moderno y en la línea con tu negocio o marca.</p> 
                            <p className={headerStyles.header_titles_text_parrafo}>A través de tu sitio web podrás mostrar a los visitantes el gran valor de tu producto o servicio. El objetivo es crear una web dirigida para tu público objetivo.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Velocidad /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Velocidad &#38; SEO</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>El rendimiento y velocidad de tu sitio web es una prioridad para mi.</p>
                            <p className={headerStyles.header_titles_text_parrafo}>Lo más importante para Google es que tu sitio web tenga una velocidad de carga rápida. Gracias a la tecnología que uso conseguirás una velocidad de carga imbatible para posicionar tu página web en los primeros puestos de Google.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Responsive /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Diseño Responsive</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>Google premia a aquellas páginas web que tengan un diseño Mobile First.</p>
                            <p className={headerStyles.header_titles_text_parrafo}>Es crucial que tu sitio web pueda adaptarse a todos los dispositivos. Cada web que diseño, se adapta para funcionar en todos los navegadores y dispositivos. Es por ello que tu web estará adaptada tanto para ordenador, como móvil y tablet.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Listo /></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Listo para usar</h3>
                            <p className={headerStyles.header_titles_text_parrafo_700}>Una vez haya desarrollado tu sitio web, lo instalaré en un servidor con su correspondiente dominio, además de estar indexada en Google.</p> 
                            <p className={headerStyles.header_titles_text_parrafo}>Tu sitio web estará integrado con un CMS que te permitirá hacer cambios sin la necesidad de un desarrollador. Te proporcionaré un training completo sobre cómo usar y modificar tu web.</p>
                        </div>


                    </div>
                    
                    <h3 className={headerStyles.header_titles_third_text}>¿Quiéres comenzar con tu proyecto web?</h3>
                    <Link to="/contacto" className="btn_small btn_small__gold">Contáctame</Link>
                    

                </div>
            </section>

            <section className={homeStyles.portfolio}>

                <div className={homeStyles.portfolio_wrapper}>

                    <div className={homeStyles.portfolio_wrapper_left}>
                        <h2 className={headerStyles.header_titles_text2}>Echa un vistazo a mi Portfolio</h2>
                        <p>Me siento muy orgulloso de mi trabajo y por qué no enseñar algunas de las páginas web que he diseñado y desarrollado.</p>
                        <Link to="/portfolio" css={css`letter-spacing: 1px;`} className="btn_small btn_small__gold" >Ver Portfolio</Link>
                    </div>
                    <div className={homeStyles.portfolio_wrapper_right}>
                        <Img fluid={data.image2.childImageSharp.fluid} alt='Portfolio Felix Gonzalo' loading="lazy"/>
                    </div>
                

                </div>
            </section>

            <section className={disenoStyles.diseno}>
                <div className={disenoStyles.diseno_wrapper}>

                    <h2 className={headerStyles.header_titles_text_white}>¿Qué tecnología uso para diseñar páginas web?</h2>
                    <h3 className={headerStyles.header_titles_subtext}>Para el desarrollo de las páginas web utilizo JAMstack y Webflow</h3>

                        <div className={disenoStyles.diseno_wrapper_wrap}>
                            <div className={disenoStyles.diseno_wrapper_wrap_left}>
                                <div className={disenoStyles.diseno_wrapper_wrap_left_box}>
                                    <Img fluid={data.image3.childImageSharp.fluid} alt="Diseño web Gatsby.js" className={disenoStyles.diseno_wrapper_wrap_left_box_img1} loading="lazy"/>
                                    <Img fluid={data.image4.childImageSharp.fluid} alt="Diseño web Gatsby.js" className={disenoStyles.diseno_wrapper_wrap_left_box_img2} loading="lazy"/>
                                    <div css={css`
                                        position: absolute;
                                        width: 55%;
                                        height: 42%;
                                        left: 2px;
                                        top: 16.5%;                              
                                        display: block;
                                        background-image: url(${BackgroundPoint});
                                        background-size: 10px;
                                        background-repeat: repeat;
                                        z-index: 0;
                                    `}></div>
                                </div>
                            </div>

                            <div className={disenoStyles.diseno_wrapper_wrap_right}>
                                <h3 className={headerStyles.header_titles_subtext_light}>Diseño y desarrollo de webs</h3>
                                <h2 className={headerStyles.header_titles_second_text_white}>Desarrollo web con JAMstack y Webflow</h2>
                                <p>Para el diseño de las páginas web, utilizo JAMstack y Webflow. Te preguntarás, <strong>¿Qué es JAMstack?</strong> Es una tecnología web que permite crear páginas web con una increíble velocidad de carga.
                                JAMstack en lugar de cargar una página cada vez que hacemos clic, esta tecnología las precarga y la muestra instantáneamente al usuario cuendo se hace clic.
                                </p>
                                
                            </div>
                        </div>

                        <div className={disenoStyles.diseno_wrapper_wrap}>
                           
                            <div className={disenoStyles.diseno_wrapper_wrap_second_right}>
                                <h3 className={headerStyles.header_titles_subtext_light}>GESTIÓN DE LA PÁGINA WEB</h3>
                                <h2 className={headerStyles.header_titles_second_text_white}>Gestiona tu web con Webflow o Contentful CMS</h2>
                                <p>Tras realizar el diseño y desarrollo del sitio web, podrás hacer los cambios que necesites y tenerla actualizada en todo momento. Dependiendo de tu proyecto, te asesoraré con el CMS (Gestor de contenidos) que mejor se adapte a tu proyecto.
                                </p>
                                
                            </div>

                            <div className={disenoStyles.diseno_wrapper_wrap_second_left}>
                                <div className={disenoStyles.diseno_wrapper_wrap_left_box}>
                                    <Img fluid={data.image5.childImageSharp.fluid} alt="Diseño web JAMstack" className={disenoStyles.diseno_wrapper_wrap_left_box_img3} loading="lazy"/>
                                    <Img fluid={data.image6.childImageSharp.fluid} alt="Diseño web webflow" className={disenoStyles.diseno_wrapper_wrap_left_box_img4} loading="lazy"/>
                                    
                                    <div css={css`
                                        position: absolute;
                                        width: 55%;
                                        height: 42%;
                                        left: 19%;
                                        top: 16.5%;                              
                                        display: block;
                                        background-image: url(${BackgroundPoint});
                                        background-size: 10px;
                                        background-repeat: repeat;
                                        z-index: 0;

                                        @media (max-width: 800px){
                                            left: 0;
                                            top: 23.5%;
                                        }
                                    `}></div>
                                </div>
                            </div>

                        </div>

                        <div className={disenoStyles.diseno_wrapper_wrap}>
                            <div className={disenoStyles.diseno_wrapper_wrap_third_left}>
                                <div className={disenoStyles.diseno_wrapper_wrap_left_box}>
                                    <Img fluid={data.cohete.childImageSharp.fluid} alt='velocidad JAMstack' css={css`
                                            position: absolute !important;
                                            left: 10%;
                                            top: 22.5%;                              
                                            display: block;
                                            z-index: 10;
                                            width: 60%;
                                            max-width: 400px;

                                            @media (max-width: 800px){
                                                left: 5%;
                                                top: 44.5%;
                                            }

                                            @media (max-width: 700px){
                                                width: 80%;
                                            }

                                            @media (max-width: 700px){
                                                top: 18.5%;
                                            }

                                    `} loading="lazy"/>
                                    <div css={css`
                                        position: absolute;
                                        width: 55%;
                                        height: 42%;
                                        left: 5%;
                                        top: 16.5%;          
                                        display: block;
                                        background-image: url(${BackgroundPoint});
                                        background-size: 10px;
                                        background-repeat: repeat;
                                        z-index: 0;
                                        
                                        @media (max-width:800px){
                                            width: 60%;
                                            height: 60%;
                                            left: -5%;
                                            top: 9.5%;
                                        }

                                        @media (max-width:700px){
                                            left: 0%;
                                            top: 6.5%;

                                        }

                                    `}></div>
                                    <div css={css`
                                        position: absolute;
                                        width: 27%;
                                        height: 44%;
                                        bottom: 5%;
                                        right: 18%;       
                                        display: block;
                                        background-image: url(${BackgroundX});
                                        background-size: 12px;
                                        background-repeat: repeat;
                                        z-index: 1;

                                        @media (max-width:1000px){
                                            width: 27%;
                                            bottom: -8%;

                                        }

                                        @media (max-width:800px){
                                            width: 40%;
                                            height: 44%;
                                            bottom: -30%;
                                            right: 15%;
                                        }

                                        @media (max-width: 700px){
                                            bottom: -5%;
                                        }
                                    `}></div>
                        
                                    <div css={css`
                                        position: absolute;
                                        width: 26%;
                                        height: 41%;
                                        bottom: 2%;
                                        right: 22%;
                                        background-color: #A58861;
                                        z-index: 0;


                                        @media (max-width:1000px){
                                            width: 31%;
                                            bottom: -13%;

                                        }

                                        @media (max-width: 800px){
                                            width: 40%;
                                            height: 44%;
                                            bottom: -26%;
                                        }

                                        @media (max-width: 700px){
                                            bottom: -12%;
                                        }
                                    `}></div>

                                </div>
                            </div>
                        
                            <div className={disenoStyles.diseno_wrapper_wrap_third_right}>
                                <h3 className={headerStyles.header_titles_subtext_light}>Ventajas de usar JAMstack</h3>
                                <h2 className={headerStyles.header_titles_second_text_white}>¿Por qué apostar por JAMstack y su velocidad?</h2>
                                <p>La principal ventaja que nos ofrece desarrollar una web con JAMstack es su <a href="https://developers.google.com/speed/pagespeed/insights/?url=https%3A%2F%2Fwww.felixdigital.es" target="_blank" rel="noopener noreferrer">velocidad de carga</a>. <br/><br/>Otro de los aspectos fundamentales que una web debe de tener es la seguridad. Con la tecnología JAMstack, tu web será super segura, ya que no los datos no provienen de una base de datos, los datos son compilados antes. Se trata de utilizar la última tecnología que existe en el mercado para el desarrollo web.
                                <br/><br/>Otra de las ventajas de JAMstack, es que <strong>NO hay que pagar hosting</strong> para la mayoría de proyectos, lo cual permite un ahorro importante.
                                </p>
                                
                            </div>
                        </div>   

                </div>

                <div className={disenoStyles.diseno_wrapper_start}>

                    <div className={disenoStyles.diseno_wrapper_wrap_right}>
                        <h3 className={headerStyles.header_titles_subtext_light}>BENEFICIOS DE MIS PÁGINAS WEB</h3>
                        <h2 className={headerStyles.header_titles_second_text_white}>Una página web creada con Webflow o JAMstack es:</h2>
                    </div>

                    <div className={disenoStyles.diseno_wrapper_start_wrap}>
                            <div className={disenoStyles.diseno_wrapper_start_wrap_box}>
                                <h3>Super Rápida</h3>
                                <p>Es increíblemente rápida. Las páginas web se cargan en milisegundos, cargan incluso hasta 10 veces más rápido.</p>
                                <Rapido />
                            </div>

                            <div className={disenoStyles.diseno_wrapper_start_wrap_box}>
                                <h3>Segura</h3>
                                <p>Gracias a que tu web estará hospedada con un CDN cómo AWS o Netlify tu web será super segura porque no trabaja con servidores. Adiós web vulnerables.</p>
                                <Seguro />
                            </div>

                            <div className={disenoStyles.diseno_wrapper_start_wrap_box}>
                                <h3>Confiable</h3>
                                <p>Trabajo con la última tecnología del mercado como son React, Webpack o GraphQL.</p>
                                <Confiable />
                            </div>

                            <div className={disenoStyles.diseno_wrapper_start_wrap_box}>
                                <h3>Ventajas SEO</h3>
                                <p>Las web desarrolladas con JAMstack, ofrecen un mejor ranking en Google, lo que equivale a más tráfico y más €€€.</p>
                                <SEO />
                            </div>

                            <div className={disenoStyles.diseno_wrapper_start_wrap_box}>
                                <h3>Escalable</h3>
                                <p>¿Más tráfico de lo habitual? No tendrás problema de caida de servidor o pagar una fortuna por servidores de respaldo.</p>
                                <Escalable />
                            </div>
                            <div className={disenoStyles.diseno_wrapper_start_wrap_box}>
                                
                            </div>

                    </div>
                    
                </div>
                <div className={disenoStyles.diseno_wrapper_center}>

                    <h3 className={headerStyles.header_titles_second_text_white}>¿Quiéres tener la web del futuro?</h3>
                    <p>Haz que tu negocio destaque sobre los demás con una web ultra rápida, destacando sobre los demás tanto en diseño como experiencia de usuario.</p>
                    <Link to="/contacto" className="btn_small btn_small__gold">Contáctame</Link>

                </div>

                
            </section>

            <section className={disenoStyles.companies}>
                <div className={disenoStyles.companies_wrapper}>
                    
                    <h3>Confían en la tecnología JAMstack para sus sitios webs</h3>
                    
                    <div className={disenoStyles.companies_wrapper_box}>
                        <div className={disenoStyles.companies_wrapper_box_img}>
                           <a href="https://www.airbnb.es" target='_blank' rel="noopener noreferrer"><Airbnb /></a>
                        </div>
                        <div className={disenoStyles.companies_wrapper_box_img}>
                            <a href="https://www.nike.com/es" target='_blank' rel="noopener noreferrer"><Nike /></a>
                        </div>
                        <div className={disenoStyles.companies_wrapper_box_img}>
                            <a href="https://deliveroo.es" target='_blank' rel="noopener noreferrer"><Deliveroo /></a>
                        </div>
                        <div className={disenoStyles.companies_wrapper_box_img}>
                            <a href="https://es.braun.com" target='_blank' rel="noopener noreferrer"><Braun /></a>
                        </div>
                        <div className={disenoStyles.companies_wrapper_box_img}>
                            <a href="https://www.hopper.com" target='_blank' rel="noopener noreferrer"><Hopper /></a>
                        </div>
                        <div className={disenoStyles.companies_wrapper_box_img}>
                            <a href="https://www.shopflamingo.com" target='_blank' rel="noopener noreferrer"><Flamingo /></a>
                        </div>

                    </div>

                </div>
            </section>

            <section className={disenoStyles.steps}>
                <div className={disenoStyles.steps_wrapper}>

                    <h2 className={headerStyles.header_titles_text}>Mi proceso para diseñar páginas web a medida</h2>
                    <div className={disenoStyles.steps_wrapper_box}>
                       
                    <h3 className={headerStyles.header_titles_subtext}>Mi forma de trabajar en el diseño de sitios webs lo estructuro en diferentes fases de trabajo.</h3>

                    </div>

                    <div className={disenoStyles.steps_wrapper_box_double}>

                        <div className={disenoStyles.steps_wrapper_box_double_left}>
                            <h4>Páginas web 100% a medida para negocios, <span className={disenoStyles.steps_wrapper_box_double_left_line}>nada de plantillas</span></h4>
                        </div>

                        <div className={disenoStyles.steps_wrapper_box_double_right}>

                            <h4 className={headerStyles.header_titles_subtext2}>Desde la comprensión de las necesidades de mi cliente, hasta el desarrollo integro de su sitio web. Estas son las fases del desarrollo de una página web para empresas:</h4>

                            <div css={css`
                                        position: absolute;
                                        width: 55%;
                                        height: 42%;
                                        right: 21%;
                                        top: 17.5%;                              
                                        display: block;
                                        background-image: url(${BackgroundPointBlack});
                                        background-size: 10px;
                                        background-repeat: repeat;
                                        z-index: 10;

                                        @media (max-width:900px){
                                            right: 0;
                                            top: 20.5%;
                                        }

                                        @media (max-width:700px){
                                            right: 0%;
                                            top: 18%;
                                        }

                                        @media (max-width:700px){
                                            right: -5%;
                                        }
                            `}></div>


                            <div className={disenoStyles.steps_wrapper_box_double_right_step}>
                                <ol>
                                    <li><span css={css`color: black;`}><strong>Análisis del mercado:</strong></span> Estudiaré tu competencia para ver como podemos diferenciarnos de ellos, conociendo sus fortalezas y debilidades.</li>
                                    
                                    <li><span css={css`color: black;`}><strong>Buying Persona:</strong></span> En este apartado el objetivo es conocer y entender a los usuarios que entrarán en el sitio web, sus objetivos y que es lo que quieren que la página web les ofrezca.</li>
                                    
                                    <li><span css={css`color: black;`}><strong>Sitemap:</strong></span> Es una visión general del sitio web, su estructura de apartados, navegación y planificación.</li>
                                    
                                    <li><span css={css`color: black;`}><strong>Wireframe:</strong></span> En este apartado nos adentramos en cada uno de las páginas de la web, el contenido que tendrán, y ver el ‘flow’ de ellas para llegar a alcanzar el objetivo de los usuarios con los menos pasos posibles.</li>
                                    
                                    <li><span css={css`color: black;`}><strong>Identidad corporativa:</strong></span> Es el look and feel del sitio web, la parte visual. Nos centraremos en la estética de botones, colores corporativos, tipos de letra, layout de la página etc.</li>

                                    <li><span css={css`color: black;`}><strong>Desarrollo de la página web:</strong></span> Comenzaré a desarrollar tu sitio web después de recabar toda la información necesaria.</li>
                                </ol>
                            </div>
                        </div>

                    </div>


                </div>
            </section>

            <section className={disenoStyles.intro}>
                <div className={disenoStyles.intro_wrapper}>

                    <div className={disenoStyles.intro_wrapper_up}>
                    
                        <h2 className={headerStyles.header_titles_text}>Tu web super rápida optimizada para SEO</h2>
                        <h3 className={headerStyles.header_titles_subtext}>¿Sabías que más del 50% por ciento de los usuarios que visitan una web, la abandonarán si carga en más de 3 segundos?</h3>

                        <p>Una vez desarrolle tu web, estará perfectamente optimizada para SEO. Implemento estrategias de diseño basadas en la investigación del mercado y la competencia. Centrando mis esfuerzos en ofrecer a los visitantes de tu sitio web, la mejor experiencia de usuario. <br></br><br></br>Esto da como resultado, que los usuarios se queden en tu página web. 
                        <br></br><br></br>Todo esto entre otros factores, harán que tu web vaya obteniendo mejores resultados en el ranking de búsqueda en Google.</p>

                        <h3 css={css`font-size:2rem;`}>La velocidad en tu web se traduce en:</h3>

                    </div>

                    <div className={disenoStyles.intro_wrapper_box}>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Img fluid={data.icon4.childImageSharp.fluid} alt="Posicionamiento Seo" css={css`width:100px`} loading="lazy"/></div>
                            <h3 className={headerStyles.header_titles_subtext_left} css={css`hyphens: auto`}>Mejor posicionamiento SEO</h3>
                            <p className={headerStyles.header_titles_text_parrafo}>Para un buen posicionamiento SEO (Posicionamiento orgánico), es crucial una que la web disponga de una gran velocidad de carga. De nada sirve crear contenido atractivo para posicionarse en buscadores, si nuestro sitio web es lento.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Img fluid={data.icon2.childImageSharp.fluid} alt="Experiencia de usuario" css={css`width:100px`} loading="lazy"/></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Increíble experiencia de usuario</h3>
                            <p className={headerStyles.header_titles_text_parrafo}><strong>Según Google</strong>, más del 50% por ciento de los usuarios que visitan tu web la abandonará si carga en más de 3 segundos. Una alta velocidad de respuesta en tu página, aumentará la posibilidad de obtener más potenciales clientes.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Img fluid={data.icon1.childImageSharp.fluid} alt="Clientes potenciales" css={css`width:100px`} loading="lazy"/></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Mayor número de clientes potenciales</h3>
                            <p className={headerStyles.header_titles_text_parrafo}>Un posicionamiento más alto se traduce en la obtención de más clientes potenciales. Cuanto menos tarde la página en cargar, más clientes e ingresos obtendrás.</p>
                        </div>

                        <div className={disenoStyles.intro_wrapper_box_service}>
                            <div className={disenoStyles.intro_wrapper_icon}><Img fluid={data.icon3.childImageSharp.fluid} alt="Mayores ingresos" css={css`width:100px`} loading="lazy"/></div>
                            <h3 className={headerStyles.header_titles_subtext_left}>Mayores ingresos</h3>
                            <p className={headerStyles.header_titles_text_parrafo}>Los sitios web que desarrollo, ofrecen un alto rendimiento respecto a la velocidad de carga. <strong>Esto ayuda a que se generen <a href="https://www.thinkwithgoogle.com/intl/es-es/canales-de-publicidad/movil/milesimas-de-segundo-que-valen-millones-la-velocidad-en-dispositivos-moviles-es-capaz-de-ralentizar-o-acelerar-el-crecimiento-de-las-empresas/" rel="noopener noreferrer" target="_blank" css={css`color:#000;`}>mayores conversiones de clientes potenciales.</a></strong></p>
                        </div>


                    </div>
                    

                </div>
            </section>

        </Layout>
    )

}

export default IndexPage
